import { defineComponent as _defineComponent } from 'vue'
import { useAutomationStore } from "@/pinia";
import { ISignal, SIGNALS_OUTPUT } from "@/shared";
import { computed, ref } from "vue";
import SignalList from "./SignalList.vue";

// computed

interface IEmits {
	(
		e: "select",
		{ signal, field, label }: { signal: ISignal; field: string; label: string }
	);
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SignalLinkModal',
  emits: ["select"],
  setup(__props, { expose, emit }: { emit: ({
	(
		e: "select",
		{ signal, field, label }: { signal: ISignal; field: string; label: string }
	);
}), expose: any, slots: any, attrs: any }) {

const signalSelected = computed<boolean>(() => signal.value !== null);

// store
const automationStore = useAutomationStore();

// data
const signal = ref<ISignal | null>(null);
const visible = ref<boolean>(false);

// methods
function selectSignal(s: ISignal) {
	signal.value = s;
}
function selectField(field: string, label: string) {
	emit("select", { signal: signal.value, field, label });
	reset();
	hide();
}
function show() {
	visible.value = true;
}
function hide() {
	visible.value = false;
}
function reset() {
	signal.value = null;
}

// emit


// expose
expose({ show, hide });

return { __sfc: true,signalSelected, automationStore, signal, visible, selectSignal, selectField, show, hide, reset, emit, SIGNALS_OUTPUT, SignalList }
}

})